import React from 'react';
import { Form, FormGroup, Col, Row } from 'react-bootstrap';
import './style.scss';
import LoadingSpinner from '../LoadingSpinner';


class CustomerInfo extends React.Component {

    render() {
        const data=this.props.customerInfo===undefined ? {} : this.props.customerInfo;
        if (this.props.customerInfo===undefined)
        {
            return (<div className="height80"><LoadingSpinner isLoading={true} /> </div>);
        }
        else
        {
            return (
            <Col sm={10}>
                <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); }}>
                    <FormGroup>
                        <Row className="row-eq-height">
                            <Col sm={3}>
                                <Row> <Col xs={4}>Customer no:</Col><Col xs={8}>{data.CLIENT_CODE_REGIONAL}</Col></Row>
                                <Row> <Col xs={4}>Name:</Col><Col xs={8}>{data.SHORT_NAME}</Col></Row>
                                <Row> <Col xs={4}>Company:</Col><Col xs={8}>{data.COMPANY}</Col></Row>
                            </Col>

                            <Col sm={3} className="left-border">
                                <Row> <Col xs={3}>Email:</Col><Col xs={9}>{data.EMAIL}</Col></Row>
                                <Row> <Col xs={3}>Phone:</Col><Col xs={9}>{data.PHONE}</Col></Row>
                                <Row> <Col xs={3}>Phone 2:</Col><Col xs={9}>{data.PHONE2}</Col></Row> 
                            </Col>
                            
                            <Col sm={2} className="left-border">
                                <Row> <Col xs={6}>Reg. number:</Col><Col xs={6}>{data.REGISTRATION_NUMBER1}</Col></Row> 
                                <Row> <Col xs={6}>Market area code:</Col><Col xs={6}>{data.MARKET_AREA_CODE}</Col></Row>
                                <Row> <Col xs={6}>Currency:</Col><Col xs={6}>{data.CURRENCY_CODE}</Col></Row> 
                            </Col>
                            
                            <Col sm={3} className="left-border">
                                <Row> <Col xs={4}>Terms of payment:</Col><Col xs={8}>{data.TERMS_OF_PAYMENT_CODE} - {data.TERMS_OF_PAYMENT_DESC}</Col></Row>
                                <Row> <Col xs={4}>Language:</Col><Col xs={8}>{data.LANGUAGE_CODE}</Col></Row>
                                <Row> <Col xs={4}>Delivery code:</Col><Col xs={8}>{data.DELIVERY_CODE}</Col></Row> 
                                <Row> <Col xs={4}>Cash discount rate:</Col><Col xs={8}>{data.CASH_DISCOUNT_RATE} {data.CASH_DISCOUNT_RATE!=null ? '%' : ''}</Col></Row> 
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
            </Col>
            )
        }
    }
}

export default CustomerInfo;